// Define constants for action types
import axios from "axios";

const FETCH_BOOKINGS_REQUEST = "FETCH_BOOKINGS_REQUEST";
const FETCH_BOOKINGS_SUCCESS = "FETCH_BOOKINGS_SUCCESS";
const FETCH_BOOKINGS_FAILURE = "FETCH_BOOKINGS_FAILURE";
const UPDATE_BOOKING_STATUS = "UPDATE_BOOKING_STATUS"; // ✅ New action type
const UPDATE_BOOKING_STATUS_FAILURE = "UPDATE_BOOKING_STATUS_FAILURE";

// Initial state
const initialBookingState = {
  bookings: [],
  loading: false,
  error: null,
};


// Reducer function
const bookingReducer = (state = initialBookingState, action) => {
  switch (action.type) {
    case FETCH_BOOKINGS_REQUEST:
      return {
        ...state,
        loading: true, // Set loading to true while fetching data
        error: null    // Clear any previous errors
      };

    case FETCH_BOOKINGS_SUCCESS:
      return {
        ...state,
        bookings: action.payload, // Update state with fetched bookings
        loading: false,           // Stop loading
        error: null               // Clear any errors
      };

    case FETCH_BOOKINGS_FAILURE:
      return {
        ...state,
        loading: false,  // Stop loading
        error: action.payload // Store the error message
      };
    case UPDATE_BOOKING_STATUS:
      return {
        ...state,
        bookings: state.bookings.map((booking) =>
          booking._id === action.payload.id
            ? { ...booking, BookingStatus: action.payload.status } // ✅ Update status immediately
            : booking
        ),
      };
    case UPDATE_BOOKING_STATUS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state; // Return the current state for unhandled action types
  }
};

export const updateBookingStatus = (status, id) => async (dispatch) => {
  const token = localStorage.getItem("sassoontoken");

  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/api/booking/${id}`,
      { BookingStatus: status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      // ✅ Update Redux store immediately
      dispatch({
        type: UPDATE_BOOKING_STATUS,
        payload: { id, status },
      });
    }
  } catch (error) {
    console.error("Error updating booking status:", error);
    dispatch({
      type: UPDATE_BOOKING_STATUS_FAILURE,
      payload: error.message,
    });
    alert("Failed to update booking status. Please try again.");
  }
};
export default bookingReducer;
